import type { FallbackProps } from 'react-error-boundary';

import { Button } from '@/components/ui/Button';
import { isDevelopment } from '@/lib/env';

/** Top-level error UI rendered when a render-time error escapes the app tree. */
export function RootErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  const message = error instanceof Error ? error.message : 'An unexpected error occurred.';

  return (
    <div
      role="alert"
      className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background p-6 text-center"
    >
      <h1 className="text-h1 font-semibold text-foreground">Something went wrong</h1>
      <p className="max-w-md text-muted">
        The application hit an unexpected error. Try again, and if the problem persists contact
        support.
      </p>
      {isDevelopment && (
        <pre className="max-w-xl overflow-auto rounded-md bg-gray-900 p-4 text-left text-small text-red-300">
          {message}
        </pre>
      )}
      <Button onClick={resetErrorBoundary}>Try again</Button>
    </div>
  );
}
